module.exports = __webpack_public_path__ + "static/media/30.d438475a.png";